/**
 * Revenue Budget Report — shared helpers.
 * Extracted from RevenueBudgetReportPage.jsx to keep the parent page trim.
 */
import { format } from 'date-fns';

export function _nextYear() {
  const now = new Date();
  return now.getFullYear() + 1;
}

export function _iso(d) {
  return format(d, 'yyyy-MM-dd');
}

export function _defaultRange() {
  const y = _nextYear();
  return { start: `${y}-01-01`, end: `${y}-12-31` };
}

export function _defaultLastYearRange(start, end) {
  const shift = (s) => {
    const d = new Date(s);
    d.setFullYear(d.getFullYear() - 1);
    return _iso(d);
  };
  return { start: shift(start), end: shift(end) };
}

export function _money(n) {
  if (n == null || Number.isNaN(n)) return '—';
  return new Intl.NumberFormat('en-GB', {
    style: 'currency', currency: 'GBP', maximumFractionDigits: 0,
  }).format(n);
}

export function _monthLabel(key) {
  // YYYY-MM → short month + short year e.g. "Jan '27"
  const [y, m] = key.split('-').map(Number);
  const d = new Date(y, m - 1, 1);
  return format(d, "MMM ''yy");
}

export const _FREQ_CHOICES = [
  { v: '__none__', label: '(use master / clear)' },
  { v: 'weekly', label: 'Weekly' },
  { v: 'fortnightly', label: 'Fortnightly' },
  { v: 'monthly', label: 'Monthly' },
  { v: 'bi-monthly', label: 'Bi-Monthly' },
  { v: 'quarterly', label: 'Quarterly' },
  { v: 'semi-annual', label: 'Semi-Annual' },
  { v: 'annual', label: 'Annual' },
  { v: 'custom', label: 'Custom (days)' },
  { v: 'adhoc', label: 'Adhoc' },
];
